import { useState } from "react";
import "./admin-courses-creation.css";
import { useNavigate } from "react-router-dom";
import Button from "../../../../ui/atoms/buttons/Button";
import InputText from "../../../../ui/atoms/inputs/input-text/InputText";
import InputSelect from "../../../../ui/atoms/inputs/input-select/InputSelect";
import InputTextArea from "../../../../ui/atoms/inputs/input-textarea/InputTextArea";
//
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useSelector } from "react-redux";
//
import { CourseSchema } from "../../../../core/utils/validators/course";
import { wait } from "../../../../core/utils/helpers";
import { onCreateCourse } from "../../services/course";
import useAxiosPrivate from "../../../../app/providers/context-provider/useAxiosPrivate";
//
import Swal from "sweetalert2";

const AdminCoursesCreation = () => {
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();
  const [isSending, setIsSending] = useState(false);

  const currentStream = useSelector(
    (state) => state?.schoolState?.currentStream
  );

  const _stream_id = currentStream?.classe_id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    resolver: yupResolver(CourseSchema),
    defaultValues: {
      classes_id: _stream_id,
    },
  });

  const onSubmit = async (data) => {
    setIsSending(true);
    Swal.fire({
      title: "Creating new course...",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
    await wait(700);
    //
    onCreateCourse(axiosPrivate,data)
      .then((response) => {
        const _data = response?.data;
        Swal.close();
        setIsSending(false);

        if (_data?.status) {
          Swal.fire({
            title: "Courses Creation",
            text: _data?.message,
            icon: "success",
            confirmButtonText: "OK",
            didOpen: () => {
              const btn = Swal.getConfirmButton(); //
              btn.style.backgroundColor = "#2840a8";
              btn.style.color = "white";
            },
          });
          reset();
        } else {
          Swal.fire({
            title: "Courses Creation",
            text: _data?.message,
            icon: "info",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        Swal.close();
        if (!error?.response) {
          Swal.fire({
            title: "Courses Creation",
            text: "No server response",
            icon: "warning",
          });
        } else {
          Swal.fire({
            title: "Courses Creation",
            text: error?.response?.data?.detail?.message,
            icon: "error",
          });
        }
      });
  };

  return (
    <form className="school-creation" onSubmit={handleSubmit(onSubmit)}>
      <div className="sc-cr-head">
        <button type="button" onClick={() => navigate(-1)}>
          ⬅️ Back to list
        </button>
        <div className="w-full d-flex justify-space-between align-center">
          <h1>🙎🏽 New Course creation</h1>
          <Button
            type={isSending ? "button" : "submit"}
            preferedStyle={isSending ? "default" : "normal"}
            title={
              isSending
                ? "Creating new course..."
                : "Validate and Create new course"
            }
          />
        </div>
      </div>
      <div className="sc-cr-body">
        <div className="w-full d-flex gap-md mb-lg">
          <div className="w-50">
            <InputText
              type={"text"}
              name={"title"}
              title={"Title"}
              error={errors?.title?.message}
              register={register}
            />
          </div>
          <div className="w-50">
            <InputSelect
              name={"language"}
              error={errors?.language?.message}
              register={register}
              data={[
                { key: "en", title: "English", is_activated: false },
                { key: "fr", title: "French", is_activated: false },
              ]}
              placeholder={"Select language"}
            />
          </div>
        </div>
        <div className="w-full d-flex">
          <InputTextArea
            name={"description"}
            title={"Description"}
            error={errors?.description?.message}
            register={register}
          />
        </div>
      </div>
    </form>
  );
};

export default AdminCoursesCreation;
